import React, { useEffect, useState } from "react";
import { Switch, Field } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import SearchResourceInGraph from "../GenericComponent/SearchResourceInGraph";
import TimeZoneSelector from "../GenericComponent/TimeZone";
import Language from "../GenericComponent/Language";
import ScopeSelectorContainer from "../../Containers/GenericContainer/ScopeSelectorContainer";
import RegionSelector from "../GenericComponent/RegionSelector";
import DataLocation from "../GenericComponent/DataLocation";
import "../CSS/CallFlowsComponent.css";

export default function ResourcesAccountComponent({ callFlowData, setCallFlowData, isEditMode, permissions }) {
  const { t } = useTranslation();
  const [formValues, setFormValues] = useState({
    id: "",
    displayName: "",
    timeZone: "",
    language: "",
    scope: "",
    region: "",
    dataLocation: "",
    isTPE: false,
  });

  useEffect(() => {
    if (callFlowData) {
      setFormValues({
        id: callFlowData.id || "",
        displayName: callFlowData.displayName || "",
        timeZone: callFlowData.timeZone || "",
        language: callFlowData.language || "",
        scope: String(callFlowData.scope || "default"),
        region: String(callFlowData.region || ""),
        dataLocation: String(callFlowData.dataLocation?.id || callFlowData.dataLocation || ""),
        isTPE: !!callFlowData.isTPE,
      });
    }
  }, [callFlowData]);

  const updateField = (field, value) => {
    // S'assurer que le scope n'est jamais null ou undefined
    const safeValue = field === "scope" && (!value || value === "") ? "default" : value;
    setFormValues((prev) => ({ ...prev, [field]: safeValue }));
    setCallFlowData((prev) => ({ ...prev, [field]: safeValue }));
  };
  return (
    <div className="callflow-resources-account-tab">
      {!callFlowData.id && (
        <Field label={t("RESOURCE")} className="field-style" required>
          <div className="div-container-search">
            <SearchResourceInGraph
              displayName={formValues.displayName}
              disabled={!permissions?.resourceAccount?.canCreate}
              onSelectUser={(resource) => {
                if (resource?.id && resource?.displayName) {
                  updateField("id", resource.id);
                  updateField("displayName", resource.displayName);
                  if (resource?.userPrincipalName) {
                    updateField("userPrincipalName", resource.userPrincipalName);
                  }
                }
              }}
            />
          </div>
        </Field>
      )}

      {callFlowData.id && (
        <div className="form-row">
          <div className="form-column">
            <Field label={t("TIME_ZONE")} className="field-style" required>
              <TimeZoneSelector 
                value={formValues.timeZone} 
                onSelect={(tz) => updateField("timeZone", tz)} 
                disabled={isEditMode ? !permissions?.resourceAccount?.canUpdate : !permissions?.resourceAccount?.canCreate} 
              />
            </Field>

            <Field label={t("LANGUAGE")} className="field-style" required>
              <Language 
                language={formValues.language} 
                setLangue={(lang) => updateField("language", lang)}
                disabled={isEditMode ? !permissions?.resourceAccount?.canUpdate : !permissions?.resourceAccount?.canCreate}
              />
            </Field>

            <Field label={t("DATA_LOCATION")} className="field-style" required>
              <DataLocation 
                value={formValues.dataLocation} 
                onSelect={(locId) => updateField("dataLocation", locId)}
                disabled={isEditMode ? !permissions?.resourceAccount?.canUpdate : !permissions?.resourceAccount?.canCreate} 
              />
            </Field>
          </div>

          <div className="form-column">
            <Field label={t("SCOPE")} className="field-style" required>
              <ScopeSelectorContainer 
                selectedScope={formValues.scope} 
                onSelect={(scopeId) => updateField("scope", scopeId)}
                disabled={isEditMode}
              />
            </Field>

            <Field label={t("REGION")} className="field-style" required>
              <RegionSelector 
                value={formValues.region} 
                onSelect={(region) => updateField("region", region)}
                disabled={isEditMode }
              />
            </Field>

            <Field label={t("TEAMS_PHONE_EXTENSIBILITY")} className="field-style">
              <div className={isEditMode ? "switch-wrapper switch-disabled-hover" : "switch-wrapper"}>
                <Switch 
                  checked={formValues.isTPE}
                  style={{cursor: isEditMode ? "not-allowed" : "pointer"}} 
                  onChange={(_, data) => updateField("isTPE", data.checked)}
                  disabled={isEditMode }
                />
              </div>
            </Field>
          </div>
        </div>
      )}
    </div>
  );
}
